var NavDrawerSlideStorage = function() {
    var slideNumQueue = [];
    
    this.addQueue = function(slideNum) {
        slideNumQueue.push(slideNum);
    };

    this.popQueue = function() {
        return slideNumQueue.pop();
    };

    this.getQueue = function() {
        return slideNumQueue;
    };

    this.clearQueue = function() {
        slideNumQueue = [];
    };
};

module.exports = new NavDrawerSlideStorage();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/drawer/slide-storage.js
// module id = 23
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14